import AbstractFilter from './AbstractFilter';

export default class StringTrim extends AbstractFilter
{
    filter(value: string | number): string
    {
        return value.toString().trim();
    }
}